import * as React from 'react';
import Select, { Props } from 'react-select';
import './style.scss';

export default class Picker extends React.Component<Props> {
  public render() {
    return <Select isSearchable={false} classNamePrefix="picker" {...this.props} />;
  }
}
